(function(){
  'use strict';
  function $all(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function closest(el, sel){ return el && el.closest ? el.closest(sel) : null; }
  function toast(msg){
    var t=document.getElementById('ss-cart-toast'), txt=document.getElementById('ss-cart-toast-text');
    if(t && txt){ txt.textContent=msg; t.classList.add('is-visible'); setTimeout(function(){t.classList.remove('is-visible');}, 2500); }
  }
  function openCartDrawerNow(){
    var drawer=document.querySelector('[data-cart-drawer], #cart-drawer');
    if(!drawer) return;
    document.body.classList.add('js-drawer-open-cart');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    $all('[data-cart-drawer-toggle]').forEach(function(b){ b.setAttribute('aria-expanded','true'); });
    document.dispatchEvent(new CustomEvent('theme:cart:open', {bubbles:true}));
  }
  function refreshDrawerHtml(){
    return fetch(window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'ss_cart_refresh=' + Date.now(), {credentials:'same-origin'})
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=doc.querySelector('[data-cart-drawer], #cart-drawer');
        var current=document.querySelector('[data-cart-drawer], #cart-drawer');
        if(fresh && current){ current.innerHTML=fresh.innerHTML; }
      }).catch(function(){});
  }
  function refreshCart(openDrawer){
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('ajaxCart:added'));
    document.dispatchEvent(new CustomEvent('theme:cart:reload'));
    patchCheckoutDiscount();
    if(openDrawer){ refreshDrawerHtml().then(function(){ openCartDrawerNow(); setTimeout(patchCheckoutDiscount, 250); }); }
  }
  document.addEventListener('click', function(e){
    var close=closest(e.target,'.cart-drawer__close, [data-cart-drawer-toggle]');
    var drawer=document.querySelector('[data-cart-drawer], #cart-drawer');
    if(close && drawer && drawer.classList.contains('is-open')){
      e.preventDefault();
      drawer.classList.remove('is-open');
      document.body.classList.remove('js-drawer-open-cart');
      $all('[data-cart-drawer-toggle]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      document.dispatchEvent(new CustomEvent('theme:cart:close', {bubbles:true}));
    }
  }, true);
  function addFirstAvailable(handle, btn){
    if(!handle || (btn && btn.dataset.loading==='1')) return;
    if(btn){ btn.dataset.loading='1'; btn.classList.add('is-loading'); }
    fetch('/products/' + handle + '.js')
      .then(function(r){ if(!r.ok) throw new Error('Produit introuvable'); return r.json(); })
      .then(function(p){
        var v=(p.variants||[]).find(function(x){ return x.available; }) || (p.variants||[])[0];
        if(!v) throw new Error('Aucune variante');
        return fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:v.id, quantity:1}) })
          .then(function(r){ if(!r.ok) throw new Error('Ajout impossible'); return r.json(); })
          .then(function(){ toast('✓ Ajouté au panier'); refreshCart(true); });
      })
      .catch(function(){ toast('Ouvre le produit pour choisir la taille'); })
      .finally(function(){ if(btn){ btn.dataset.loading='0'; btn.classList.remove('is-loading'); } });
  }
  function updateOutfitArrows(panel){
    if(!panel) return; var track=panel.querySelector('.ss-outfits__track'); if(!track) return;
    var prev=panel.querySelector('.ss-outfits__arrow--prev'), next=panel.querySelector('.ss-outfits__arrow--next');
    var max=Math.max(0, track.scrollWidth-track.clientWidth-4);
    if(prev) prev.classList.toggle('ss-outfits__arrow--hidden', track.scrollLeft <= 4);
    if(next) next.classList.toggle('ss-outfits__arrow--hidden', track.scrollLeft >= max || max <= 4);
  }
  function updateBrandArrows(panel){
    if(!panel) return; var track=panel.querySelector('.ss-brand__track'); if(!track) return;
    var max=Math.max(0, track.scrollWidth-track.clientWidth-4);
    panel.classList.toggle('has-scrolled', track.scrollLeft > 4);
    panel.classList.toggle('is-end', track.scrollLeft >= max || max <= 4);
  }
  function activateGeneric(root, prefix, idx){
    if(!root) return; idx=String(idx);
    $all('.'+prefix+'__tab-btn', root).forEach(function(btn){ btn.classList.toggle('active', btn.getAttribute('data-tab')===idx); });
    $all('.'+prefix+'__panel', root).forEach(function(panel){
      var active=panel.getAttribute('data-tab')===idx;
      panel.classList.toggle('active', active);
      if(active){
        var track=panel.querySelector('.'+prefix+'__track'); if(track) track.scrollTo({left:0, behavior:'auto'});
        setTimeout(function(){ prefix==='ss-outfits' ? updateOutfitArrows(panel) : updateBrandArrows(panel); }, 50);
        var see=root.querySelector('.'+prefix+'__see-more');
        var tab=root.querySelector('.'+prefix+'__tab-btn[data-tab="'+idx+'"]');
        var url=panel.getAttribute('data-see-more-url') || (tab && tab.dataset ? tab.dataset.seeMore : '');
        if(see && url) see.href=url;
      }
    });
  }
  function targetTwo(track, direction, cardSelector){
    var cards=$all(cardSelector, track); if(!cards.length) return track.scrollLeft + direction * Math.round(track.clientWidth * 0.75);
    var positions=cards.map(function(card){ return card.offsetLeft; });
    var current=track.scrollLeft, index=0;
    for(var i=0;i<positions.length;i++){ if(positions[i] <= current+8) index=i; }
    var targetIndex=Math.max(0, Math.min(cards.length-1, index + direction*2));
    return Math.min(positions[targetIndex], Math.max(0, track.scrollWidth-track.clientWidth));
  }
  function move(panel, prefix, direction){
    var track=panel && panel.querySelector('.'+prefix+'__track'); if(!track) return;
    track.scrollTo({ left: targetTwo(track, direction, '.'+prefix+'__card'), behavior:'smooth' });
    setTimeout(function(){ prefix==='ss-outfits' ? updateOutfitArrows(panel) : updateBrandArrows(panel); }, 120);
    setTimeout(function(){ prefix==='ss-outfits' ? updateOutfitArrows(panel) : updateBrandArrows(panel); }, 520);
  }
  document.addEventListener('click', function(e){
    // Les boutons + sont gérés par les sections elles-mêmes afin d'ouvrir
    // le sélecteur rapide de taille. Ne pas intercepter ici, sinon cela ajoute
    // directement la première variante au panier et bloque le panneau taille.
    var outfitTab=closest(e.target,'.ss-outfits__tab-btn');
    if(outfitTab){ e.preventDefault(); e.stopPropagation(); activateGeneric(closest(outfitTab,'.ss-outfits'), 'ss-outfits', outfitTab.getAttribute('data-tab')); return; }
    var brandTab=closest(e.target,'.ss-brand__tab-btn');
    if(brandTab){ e.preventDefault(); e.stopPropagation(); activateGeneric(closest(brandTab,'.ss-brand'), 'ss-brand', brandTab.getAttribute('data-tab')); return; }
    var outfitPrev=closest(e.target,'.ss-outfits__arrow--prev'); if(outfitPrev){ e.preventDefault(); e.stopPropagation(); move(closest(outfitPrev,'.ss-outfits__panel'), 'ss-outfits', -1); return; }
    var outfitNext=closest(e.target,'.ss-outfits__arrow--next'); if(outfitNext){ e.preventDefault(); e.stopPropagation(); move(closest(outfitNext,'.ss-outfits__panel'), 'ss-outfits', 1); return; }
    var brandPrev=closest(e.target,'.ss-brand__arrow--prev'); if(brandPrev){ e.preventDefault(); e.stopPropagation(); move(closest(brandPrev,'.ss-brand__panel'), 'ss-brand', -1); return; }
    var brandNext=closest(e.target,'.ss-brand__arrow--next'); if(brandNext){ e.preventDefault(); e.stopPropagation(); move(closest(brandNext,'.ss-brand__panel'), 'ss-brand', 1); return; }
  }, true);
  var productCache = {};
  function normalize(str){ return String(str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
  function isClearlyNotShoe(text){
    text = normalize(text);
    return /(outfit|ensemble|casquette|bonnet|echarpe|sac|bag|chemise|shirt|tee|t-shirt|short|pantalon|jogging|robe|jupe|accessoire)/.test(text);
  }
  function isShoeProduct(p, fallback){
    var text = normalize([fallback && fallback.title, fallback && fallback.product_type, fallback && fallback.handle, p && p.title, p && p.type, p && p.product_type, p && p.handle, (p && p.tags || []).join(' ')].join(' '));
    if(isClearlyNotShoe(text)) return false;
    return /(chaussure|chaussures|sneaker|sneakers|shoe|shoes|paire|paires|nike|tn|air max|dior b|b30|b22|b25|asics|nyc|saucony|prada|adidas|new balance|nb |p-6000|p6000|running)/.test(text);
  }
  function fetchProductInfo(item){
    var handle = item && item.handle;
    if(!handle) return Promise.resolve(null);
    if(productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .catch(function(){ return null; });
    return productCache[handle];
  }
  function countEligibleShoes(cart){
    var items = (cart && cart.items) || [];
    return Promise.all(items.map(function(item){
      return fetchProductInfo(item).then(function(p){
        return isShoeProduct(p, item) ? (item.quantity || 0) : 0;
      });
    })).then(function(counts){
      return counts.reduce(function(a,b){ return a + b; }, 0);
    });
  }
  function patchCheckoutDiscount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      return countEligibleShoes(cart).then(function(shoeQty){
        var eligible = shoeQty >= 3;
        $all('a[href*="/checkout"], button[name="checkout"], .cart__checkout').forEach(function(el){
          // La remise doit être créée côté Shopify en remise automatique.
          // Ici on ne force plus aucun code promo : le client ne voit/rentre aucun code.
          if(el.tagName === 'A' && el.getAttribute('href') && el.getAttribute('href').indexOf('/discount/') !== -1){
            el.href = '/checkout';
          }
          el.dataset.ssEligibleShoes = eligible ? '1' : '0';
        });
        document.documentElement.classList.toggle('ss-shoe-discount-ready', eligible);
      });
    }).catch(function(){});
  }
  function boot(){
    $all('.ss-outfits').forEach(function(root){ activateGeneric(root,'ss-outfits',(root.querySelector('.ss-outfits__tab-btn.active')||root.querySelector('.ss-outfits__tab-btn')||{}).getAttribute?.('data-tab') || 0); });
    $all('.ss-brand').forEach(function(root){ activateGeneric(root,'ss-brand',(root.querySelector('.ss-brand__tab-btn.active')||root.querySelector('.ss-brand__tab-btn')||{}).getAttribute?.('data-tab') || 0); });
    $all('.ss-outfits__track').forEach(function(t){ if(!t.dataset.ssScrollBound){ t.dataset.ssScrollBound='1'; t.addEventListener('scroll', function(){ updateOutfitArrows(closest(t,'.ss-outfits__panel')); }, {passive:true}); }});
    $all('.ss-brand__track').forEach(function(t){ if(!t.dataset.ssScrollBound){ t.dataset.ssScrollBound='1'; t.addEventListener('scroll', function(){ updateBrandArrows(closest(t,'.ss-brand__panel')); }, {passive:true}); }});
    patchCheckoutDiscount();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  var checkoutRefreshTimer;
  function scheduleCheckoutRefresh(){
    clearTimeout(checkoutRefreshTimer);
    checkoutRefreshTimer = setTimeout(patchCheckoutDiscount, 300);
  }
  document.addEventListener('cart:refresh', scheduleCheckoutRefresh);
  document.addEventListener('ajaxCart:added', scheduleCheckoutRefresh);
  document.addEventListener('shopify:section:load', function(){ setTimeout(boot, 80); });
})();

/* SNEAKSTYLE SEARCH SAFETY PATCH V38 */
(function(){
  'use strict';
  function qs(s,r){return (r||document).querySelector(s);}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  function openSearch(){
    var search=qs('[data-nav-search]');
    if(!search) return;
    search.classList.add('nav-search--is-visible');
    search.setAttribute('aria-expanded','true');
    document.documentElement.classList.add('ss-search-lock');
    document.body.classList.add('ss-search-lock','is-search-visible');
    var header=qs('[data-site-header]');
    if(header) header.classList.add('is-search-visible');
    setTimeout(function(){ var input=qs('[data-nav-search-input]', search); if(input) input.focus(); }, 60);
  }
  function closeSearch(){
    var search=qs('[data-nav-search]');
    if(!search) return;
    search.classList.remove('nav-search--is-visible');
    search.setAttribute('aria-expanded','false');
    document.documentElement.classList.remove('ss-search-lock');
    document.body.classList.remove('ss-search-lock','is-search-visible');
    var header=qs('[data-site-header]');
    if(header) header.classList.remove('is-search-visible');
  }
  function submitSearch(form){
    var input=qs('[data-nav-search-input]', form);
    var q=(input && input.value || '').trim();
    if(!q){ if(input) input.focus(); return; }
    window.location.href=(window.theme && theme.routes && theme.routes.search_url ? theme.routes.search_url : '/search') + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
  }
  document.addEventListener('click', function(e){
    var opener=e.target.closest && e.target.closest('[data-nav-search-open]');
    var closer=e.target.closest && e.target.closest('[data-nav-search-close]');
    var quick=e.target.closest && e.target.closest('.sneakstyle-search__quicklinks a');
    if(opener){ e.preventDefault(); e.stopPropagation(); openSearch(); return; }
    if(closer){ e.preventDefault(); e.stopPropagation(); closeSearch(); return; }
    if(quick){
      var href=quick.getAttribute('href');
      if(href && href.indexOf('/collections/')===0) return;
    }
  }, true);
  document.addEventListener('submit', function(e){
    var form=e.target.closest && e.target.closest('[data-nav-search-form]');
    if(!form) return;
    e.preventDefault();
    e.stopPropagation();
    submitSearch(form);
  }, true);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeSearch(); });
  qsa('[data-nav-search]').forEach(function(search){ search.setAttribute('aria-expanded', search.classList.contains('nav-search--is-visible') ? 'true' : 'false'); });
})();
